let currentIndex = 0; // Initialize the starting slide index

// Scroll Right (Next Slide)
if(document.querySelector(".image-arrows")){
  
document.querySelector(".image-arrows #nextArrow").addEventListener("click", () => {
  const slider = document.querySelector(".mlveda-custom-slider-component");

  if (slider) {
    const totalSlides = slider.children.length;
    const slideWidth = slider.scrollWidth / (totalSlides );

    // Increment the current index until the last slide
    if (currentIndex < totalSlides - 1) {
      currentIndex++;
    } else {
      currentIndex = 0; // Reset to the first slide if the end is reached
    }

    // Scroll the slider to the calculated position based on the current index
    slider.scrollTo({
      left: slideWidth * currentIndex,
      behavior: "smooth" // Adds smooth scrolling effect
    });
  }
});

  

// Scroll Left (Previous Slide)
document.querySelector(".image-arrows #prevArrow").addEventListener("click", () => {
  const slider = document.querySelector(".mlveda-custom-slider-component");

  if (slider) {
    const totalSlides = slider.children.length;
    const slideWidth = slider.scrollWidth / ( totalSlides );

    // Decrement the current index to go back to the previous slide
    if (currentIndex > 0) {
      currentIndex--;
    } else {
      currentIndex = totalSlides - 1; // Go to the last slide if the beginning is reached
    }

    // Scroll the slider to the calculated position based on the current index
    slider.scrollTo({
      left: slideWidth * currentIndex,
      behavior: "smooth" // Adds smooth scrolling effect
    });
  }
});

document.querySelectorAll(".mlveda-custom-thumbnails li").forEach((slide)=>{
  slide.addEventListener("click",()=>{
    // console.log("click");
     const slider = document.querySelector(".mlveda-custom-slider-component");
    const totalSlides = slider.children.length;
     currentIndex = Number(slide.getAttribute("data-media-position")) - 1;
      // console.log("currentIndex: ", currentIndex);
})


  })
 
function setIndexToZero(){
        currentIndex = 0;
        console.log("currentIndex: ",currentIndex);
        
}
}